import React, { PropsWithChildren } from "react";
//#region types
import { GroupSectionInlineProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Icon from "../../icon";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const GroupSectionInline: React.FC<PropsWithChildren<GroupSectionInlineProps>> = (props) => {
  const { label, icon } = props;

  return (
    <Grid container item className={cssExports.groupSectionInline} direction="row">
      <Grid item container sm={3}>
        <Grid item container direction="row" className={cssExports.formSectionHeader}>
          {icon && (
            <Grid item>
              <Icon icon={icon} />
            </Grid>
          )}
          {label && <Grid item>{LocalizationHelperInstance.getFormattedMessage(label, label)}</Grid>}
        </Grid>
      </Grid>
      <Grid container item xs direction="row" className={cssExports.formSectionDetails}>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default GroupSectionInline;
